import { render, staticRenderFns } from "./IconFemaleSymbol.vue?vue&type=template&id=011558ca"
import script from "./IconFemaleSymbol.vue?vue&type=script&lang=js"
export * from "./IconFemaleSymbol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports